// 다이소몰 챗봇 위젯 (PC 웹)
// 별도 브라우저 창이 아니라, 현재 페이지 우측 하단에 iframe 패널로 띄운다.
const CHATBOT_URL = 'https://qs.hiqri.ai/webchat/daisomall/'
const OVERLAY_ID = 'daiso-chatbot-overlay'

// 챗봇 위젯 열기/닫기 토글
export function toggleChatbotWidget () {
  const exist = document.getElementById(OVERLAY_ID)
  // 이미 열려 있으면 닫기
  if (exist) {
    exist.remove()
    return
  }

  // 위젯 컨테이너 (우측 하단 고정)
  const wrap = document.createElement('div')
  wrap.id = OVERLAY_ID
  wrap.style.cssText = [
    'position:fixed',
    'right:20px',
    'bottom:20px',
    'width:520px',
    'height:800px',
    'max-width:calc(100vw - 40px)',
    'max-height:calc(100vh - 40px)',
    'z-index:99999',
    'border-radius:12px',
    'overflow:hidden',
    'background:#fff',
    'box-shadow:0 8px 24px rgba(0, 0, 0, 0.25)'
  ].join(';')

  // 닫기 버튼
  const closeBtn = document.createElement('button')
  closeBtn.type = 'button'
  closeBtn.setAttribute('aria-label', '챗봇 닫기')
  closeBtn.textContent = '✕'
  closeBtn.style.cssText = [
    'position:absolute',
    'top:8px',
    'right:8px',
    'width:28px',
    'height:28px',
    'border:0',
    'border-radius:50%',
    'background:rgba(0, 0, 0, 0.5)',
    'color:#fff',
    'font-size:14px',
    'line-height:28px',
    'cursor:pointer',
    'z-index:1'
  ].join(';')
  closeBtn.addEventListener('click', () => wrap.remove())

  // 챗봇 iframe
  const iframe = document.createElement('iframe')
  iframe.src = CHATBOT_URL
  iframe.title = '다이소몰 챗봇 상담'
  iframe.allow = 'microphone; camera; clipboard-write'
  iframe.style.cssText = 'width:100%;height:100%;border:0;display:block;'

  wrap.appendChild(iframe)
  wrap.appendChild(closeBtn)
  document.body.appendChild(wrap)
}
